import request from '@/utils/request'

export function GetStaticPageDetailApi(id) {
    return request.post(
        process.env.VUE_APP_API_HOST + '/static-page/get-detail',
        {id},
        {}
    )
}
